module.exports = __webpack_public_path__ + "static/media/life_skills.b50847a1.png";